import { render, staticRenderFns } from "./ProfilePictureComponent.vue?vue&type=template&id=f4b71cf0&"
import script from "./ProfilePictureComponent.vue?vue&type=script&lang=js&"
export * from "./ProfilePictureComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePictureComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports